module.exports = __webpack_public_path__ + "static/img/mobile_code.e10c376.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_code.png
// module id = vLsl
// module chunks = 1